import React, { useState } from "react";
import DropDown from "./dropdown";
import FileUpload from "./fileUploadInput";
import Navbar from "./ui/Navbar";
import UploadSuccessModal from "./ui/UploadSuccessModal";
import { onMessageListener } from "../firebase/firebaseConfig";
import { toast } from "react-toastify";

export default function Hero() {
  const [selesctedPreset, setSelectedPreset] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [fileDownloadUrl, setFileDownLoadUrl] = useState(null);

  onMessageListener()
    .then((payload) => {
      const { title, body } = payload.data;
      toast.info(`${title}; ${body}`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    })
    .catch((err) => {
      toast.error(JSON.stringify(err), {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    });

  return (
    <div className="relative min-h-screen overflow-hidden text-white">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -top-40 left-1/2 h-[28rem] w-[28rem] -translate-x-1/2 rounded-full bg-accent/10 blur-3xl"
      />

      <UploadSuccessModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        downloadUrl={fileDownloadUrl}
      />

      <div className="relative pb-16 sm:pb-24">
        <Navbar showUpload={false} />

        <main className="mt-16 sm:mt-24">
          <div className="mx-auto max-w-3xl px-4 text-center">
            <h1 className="font-display text-4xl font-bold leading-tight tracking-tight sm:text-5xl md:text-7xl">
              Upload your <span className="text-accent">mp3/wav</span>
            </h1>
            <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-white/70 sm:text-xl">
              Upload your mp3/wav file into the upload file area and select the
              desired output preset and hit the upload button. You'll get an
              email notification when your file is ready to download.
            </p>
            <p className="mt-4 text-sm font-medium text-white/50">
              NOTE: Minimum filesize is 100kb · Maximum upload size is 100Mb
            </p>

            <div className="mt-10 flex flex-col flex-wrap items-center justify-center gap-5 sm:flex-row sm:items-center">
              <DropDown
                selesctedPreset={selesctedPreset}
                setSelectedPreset={setSelectedPreset}
              />
              <FileUpload
                setIsOpen={setIsOpen}
                setFileDownLoadUrl={setFileDownLoadUrl}
                selesctedPreset={selesctedPreset}
              />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
